import { render, staticRenderFns } from "./LaborNoticeFilter.vue?vue&type=template&id=63afb505"
import script from "./LaborNoticeFilter.vue?vue&type=script&lang=js"
export * from "./LaborNoticeFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63afb505')) {
      api.createRecord('63afb505', component.options)
    } else {
      api.reload('63afb505', component.options)
    }
    module.hot.accept("./LaborNoticeFilter.vue?vue&type=template&id=63afb505", function () {
      api.rerender('63afb505', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/labor_notice/components/LaborNoticeFilter.vue"
export default component.exports